import { useTranslation } from "react-i18next";
import { KYCWarningModal } from "@features/KYCWarningModal/KYCWarningModal";
import { Button } from "@components/Button";
import { parseHtml } from "@components/HTMLParser/utils";
import { Notification } from "@components/Notification/Notification";
import { useModalActions } from "@store/modal/modal";
import { useCustomerMetadataQuery } from "@services/customer/queries";
import { PaymentRestrictionType } from "@services/payments/types";

export const PaymentRestrictionNotification: React.FC = () => {
  const { data: metadata } = useCustomerMetadataQuery();
  const { t } = useTranslation();
  const { create } = useModalActions();

  const type =
    metadata?.paymentRestriction.paymentRestrictionTypeId ??
    PaymentRestrictionType.NoRestriction;

  const handleButtonClick = () => {
    if (type === PaymentRestrictionType.NotFilledKYC) {
      create((modalProps) => <KYCWarningModal {...modalProps} />);
      return;
    }
  };

  if (
    type === PaymentRestrictionType.NoRestriction ||
    metadata?.paymentRestriction.showPaymentRestrictionNotification === false ||
    metadata?.paymentRestriction.showPaymentRestrictionNotification ===
      undefined
  ) {
    return null;
  }

  return (
    <Notification
      color="purple"
      imagePath="/images/notification/bill-icon.png"
      variant="big"
      title={t(`paymentRestrictionNotification.${type}.title`)}
      description={
        parseHtml(
          t(`paymentRestrictionNotification.${type}.description`),
        ) as string
      }
      button={
        type === PaymentRestrictionType.NotFilledKYC ? (
          <Button onClick={handleButtonClick}>
            {t(`paymentRestrictionNotification.${type}.button`)}
          </Button>
        ) : undefined
      }
    />
  );
};
